<template>
  <div class="d-block">
    <filter-searching-wrapper
      :functional-code="functionalCode.CORPORATE"
      :searching-function="corporateService.filterSearching"
      :base-card-search-attrs="{
        'route-name-create': 'CorporateCreate',
      }"
      :fields="fields"
      use-filter-template
    >
      <template #table-colgroup-custom="scope" v-if="fields.length">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{
            'min-width': field.key == 'corporate_name' ? '150px' : '100px',
          }"
          :width="
            field.key === 'corporate_name'
              ? '50%'
              : field.key === 'member_type'
              ? '25%'
              : field.key === 'corporate_member_quantity'
              ? '15%'
              : '10%'
          "
        />
      </template>

      <template #create-data>
        <router-link :to="{ name: 'CorporateCreate' }">
          <b-button variant="success">{{ $t("panel.label_create") }}</b-button>
        </router-link>
      </template>

      <!-- cell name -->
      <template #cell(corporate_name)="{ data }">
        <span class="td-break-word">{{ data.item.name }}</span>
      </template>

      <!-- member_type -->
      <template #cell(member_type)="{ data }">
        <span class="td-break-word">{{ data.item.member_type_names }}</span>
      </template>

      <!-- corporate_member_quantity -->
      <template #cell(corporate_member_quantity)="{ data }">
        <span class="td-break-word">{{
          data.item.member_quantity_registered
        }}</span>
      </template>
      cell index
      <template #cell(action)="{ data }">
        <div class="d-flex justify-content-center" style="gap: 5px">
          <router-link
            :to="{
              name: 'StaffManagement',
              params: { corporate_code: data.item.code },
            }"
          >
            <b-button variant="secondary"
              >{{ $t("corporate.btn_staff") }}
            </b-button>
          </router-link>
          <!-- view detail -->
          <router-link
            :to="{ name: 'CorporateEdit', params: { id: data.item.id } }"
          >
            <b-button variant="primary">{{ $t("panel.label_edit") }} </b-button>
          </router-link>
          <router-link
            :to="{ name: 'CorporateDetail', params: { id: data.item.id } }"
          >
            <b-button variant="info">{{ $t("panel.label_detail") }} </b-button>
          </router-link>
        </div>
      </template>
    </filter-searching-wrapper>
  </div>
</template>

<script setup>
import FilterSearchingWrapper from "@/components/FilterSearching/FilterSearchingWrapper";
import { functionalCode } from "@/constants/advanced-filter";
import { onMounted, ref } from "vue";
import { VueInstanceProxy } from "@/hooks/useVueInstance";
import corporateService from "@/services/manage/corporate";

const _instance = VueInstanceProxy();

const fields = ref([]);
onMounted(() => {
  getCmsSearch();
});

const getCmsSearch = async () => {
  try {
    const response = await corporateService.getCorporateCmsSearch(
      _instance.$facilityCode
    );
    if (response.result_fields) {
      fields.value = [...response.result_fields, { key: "action", label: "" }];
    }
  } catch (err) {
    console.log(err);
  }
};
</script>

<style lang="scss" scoped></style>
